type ToastColor = 'success' | 'error' | 'warning' | 'info'

export type ToastNotifyFn = (message?: string, title?: string) => void

export type ToastApp = {
  $showMessage: ToastNotifyFn
  $showError: ToastNotifyFn
  $showWarning: ToastNotifyFn
  $showInfo: ToastNotifyFn
}

export function useToastApp(): ReturnType<typeof useNuxtApp> & ToastApp {
  return useNuxtApp() as ReturnType<typeof useNuxtApp> & ToastApp
}

export function useToastNotify() {
  const toast = useToast()

  const notify = (
    color: ToastColor,
    defaultTitle: string,
    icon: string,
    message?: string,
    title?: string
  ) => {
    if (!message)
      return
    toast.add({
      title: title || defaultTitle,
      color,
      description: message,
      icon
    })
  }

  return {
    showMessage: (message?: string, title?: string) => notify('success', 'Aviso', 'i-lucide-check', message, title),
    showError: (message?: string, title?: string) => notify('error', 'Erro', 'i-lucide-x', message, title),
    showWarning: (message?: string, title?: string) => notify('warning', 'Atenção', 'i-lucide-alert-triangle', message, title),
    showInfo: (message?: string, title?: string) => notify('info', 'Informação', 'i-lucide-info', message, title)
  }
}
